import React, { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import CircularLoader from "../../../../components/loader/CircularLoader";
import RecordNotFound from "../../../../components/recordNotFound/RecordNotFound";
import GeneralMUIDialog from "../../../../components/GeneralMUIDialog/GeneralMUIDialog";
import { useIds } from "../../../../hook/AdminContext";
import AppliedFilters from "../../../../components/AppliedFilters/AppliedFilters";
import { get_leader_listing } from "../../../../DAL/Leaders/Leader";
import CoachesFilter from "../Coaches/components/CoachesFilter";
import CoachesCard from "../Coaches/components/CoachesCard";
import { CircularProgress } from "@mui/material";
import CommingSoon from "../../../../components/recordNotFound/CommingSoon";

export default function LeadersPage({
  searchText = "",
  filterModal,
  setFilterModal,
  overViewType,
}) {
  const { userInfo } = useIds();
  const [leadersList, setLeadersList] = useState([]);
  const [filterData, setFilterData] = useState({
    type: null,
    list: "all",
  });
  const [appliedFilterData, setAppliedFilterData] = useState(null);
  const [filterChange, setFilterChange] = useState(false);
  const [loading, setLoading] = useState(true);

  const { source_slug, type_slug, feature_slug } = useParams();

  // load more functionality
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const observer = useRef();

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages > pageNumber) {
          handleLoadMore();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, observer]
  );

  const handleLoadMore = () => {
    setIsLoadingMore(true);
    setPageNumber(pageNumber + 1);
    handleGetLeaders(pageNumber + 1, true);
  };

  const handleGetLeaders = async (page = 0, loadingMore = false) => {
    if (!loadingMore) {
      setLoading(true);
    }
    const resp = await get_leader_listing(source_slug, searchText, page);
    if (resp.code == 200) {
      if (loadingMore) {
        setLeadersList([...leadersList, ...resp.data?.leaders]);
      } else {
        setLeadersList(resp.data?.leaders);
      }
      setPageNumber(page);
      setTotalPages(resp.data.total_page);
      // setAppliedFilterData(filterData);
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setIsLoadingMore(false);
    setLoading(false);
  };

  // const handleFilterData = () => {
  //   setFilterModal(false);
  //   handleGetLeaders();
  // };

  useEffect(() => {
    handleGetLeaders();
  }, [searchText, filterChange]);

  return (
    <>
      {/* {filterModal && (
        <GeneralMUIDialog
          open={filterModal}
          setOpen={setFilterModal}
          title="Filter"
          actionText="Filter"
          content={
            <CoachesFilter inputs={filterData} setInputs={setFilterData} />
          }
          onSubmit={handleFilterData}
        />
      )} */}
      <div className="overview-coaches my-3">
        <div className="d-flex justify-content-between align-items-start flex-column flex-md-row flex-nowrap">
          <h6 className="tw-mb-3">Leaders</h6>
        </div>
        {/* {appliedFilterData && (
          <div>
            <AppliedFilters
              filterData={appliedFilterData}
              setFilterData={setFilterData}
              onFilterChange={() => {
                setFilterChange(!filterChange);
              }}
            />
          </div>
        )} */}
        {loading ? (
          <CircularLoader />
        ) : leadersList.length > 0 ? (
          <>
            <div className="row">
              {leadersList.map((item, index) => (
                <>
                  <CoachesCard
                    isCrudAllow={false}
                    item={item}
                    handleNavigateDetails={() => {}}
                    handleOpenEditCoach={() => {}}
                    handleGetCoaches={handleGetLeaders}
                    overViewType={overViewType}
                  />
                </>
              ))}
            </div>

            {!loading &&
              totalPages > 1 &&
              totalPages > pageNumber &&
              leadersList.length > 0 && (
                <div className="col-12 text-center mt-3">
                  <div
                    ref={lastBookElementRef}
                    className="mt-3"
                    onClick={() => {
                      handleLoadMore();
                    }}
                    id="load-more-feed"
                  >
                    {isLoadingMore ? (
                      <CircularProgress size={15} />
                    ) : (
                      "Load More"
                    )}
                  </div>
                </div>
              )}
          </>
        ) : (
          <CommingSoon />
        )}
      </div>
    </>
  );
}
